import Lenis from "lenis";
import { onReducedMotionChange, prefersReducedMotion } from "../helpers/reducedMotion.js";

const lenis = new Lenis({
    anchors: true,
    autoRaf: true,
    touchMultiplier: 0,
});

// The instance is constructed unconditionally, even under reduced motion. nav.js drives
// the mobile scroll lock through lenis.stop()/start(), and it is the `lenis-stopped`
// class Lenis puts on <html> that lenis.css turns into `overflow: clip` — so skipping
// the instance would take the scroll lock with it. Switch the smoothing off instead.
//
// smoothWheel: false makes Lenis hand a wheel gesture straight back to the browser: it
// marks the scroll native and returns without preventDefault, so the page scrolls at
// native speed with no interpolation. Touch needs nothing — touchMultiplier: 0 zeroes
// the delta and syncTouch is off by default, so it was already native. `anchors` accepts
// ScrollToOptions in place of `true`, and `immediate` drops the eased jump on same-page
// links like the header's #platform and the skip link.
//
// Both options are read per event rather than captured at construction, so assigning
// them is all a mid-session preference flip needs.
const applyMotionPreference = () => {
    const reduce = prefersReducedMotion();

    lenis.options.smoothWheel = !reduce;
    lenis.options.anchors = reduce ? { immediate: true } : true;
};

applyMotionPreference();
onReducedMotionChange(applyMotionPreference);

export default lenis;
